import { render, staticRenderFns } from "./ApplianceModel.vue?vue&type=template&id=5117dee6"
import script from "./ApplianceModel.vue?vue&type=script&lang=js"
export * from "./ApplianceModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports